const features = [
  {
    icon: 'ri-4k-line',
    title: '高清画质',
    desc: '全站资源支持720P至1080P高清画质，采用先进编码技术，在保证清晰度的同时优化带宽占用，让每一帧都纤毫毕现。',
    color: 'bg-accent-100 text-accent-600',
  },
  {
    icon: 'ri-flashlight-line',
    title: '即点即播',
    desc: '无需下载、无需安装、无需等待，点击即可播放。多线CDN加速配合智能缓冲技术，真正做到零延迟观影体验。',
    color: 'bg-primary-100 text-primary-600',
  },
  {
    icon: 'ri-smartphone-line',
    title: '多端适配',
    desc: '全面支持电脑、平板和手机浏览器访问，自适应屏幕尺寸和分辨率，无论在家中还是出行途中都能畅享高清影视。',
    color: 'bg-secondary-100 text-secondary-700',
  },
  {
    icon: 'ri-refresh-line',
    title: '每日更新',
    desc: '专业内容运营团队每日追踪最新影视资源，热门剧集播出后第一时间上线，用户无需苦等更新，追剧快人一步。',
    color: 'bg-accent-100 text-accent-600',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全纯净',
    desc: '网站不含恶意广告、弹窗和强制跳转，观影过程纯净无干扰。所有资源经过安全检测，保障用户设备和隐私安全。',
    color: 'bg-primary-100 text-primary-600',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            平台优势
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            选择农民影视的五大理由，用心做好免费高清影视服务
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5 md:gap-6">
          {features.map((feat) => (
            <article
              key={feat.title}
              className="group bg-white rounded-xl p-5 md:p-6 border border-background-200/70 hover:shadow-md transition-all duration-300 cursor-pointer"
            >
              <div className={`w-11 h-11 flex items-center justify-center rounded-xl mb-4 transition-transform group-hover:scale-110 ${feat.color}`}>
                <i className={`${feat.icon} text-xl`}></i>
              </div>
              <h3 className="text-sm md:text-base font-heading text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">
                {feat.title}
              </h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                {feat.desc}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}